
import moduleCashflow from "@/store/cashflow/moduleCashFlow.js";
import { odtHostname } from '@/environment/environment'

export default {
  components: {
  },
  data() {
    return {
      selected: [],
      isMounted: false,
      searchQuery: "",
      showMyCompilation: false,
      attempts: 0,
      isCalculating: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    compilations() {
      if (this.showMyCompilation)
        return this.$store.state.cashflow.compilations.filter(l => l.createdBy.includes(this.$auth.getUser().username));
      else
        return this.$store.state.cashflow.compilations;
    }
  },
  methods: {
    addNewData() {
      this.$router.push({ name: 'BSG-cashflow-compilations-compilationEdit', params: { editData: null} });
    },
    editData(data) {
      this.$router.push({ name: 'BSG-cashflow-compilations-compilationEdit', params: { editData: data } });
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('CashFlow.Compilation.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    canCalculate(tr) {
      return tr.elementYearlyPriceTemplateId !== null && tr.yearlyFxRateTemplateId !== null && tr.yearlyInflationRateTemplateId !== null;
    },
    getCalculationDateClass(tr) {
      return !this.isValidCalculationDate(tr) ? 'text-warning' : '';
    },
    isValidCalculationDate(tr) {
      return tr.calculationDate !== null && (
        tr.calculationDate >= tr.modificationDate ||
        (tr.calculationDate !== null && tr.modificationDate === null) // This is weird but it is necessary on my local DB
      );
    },
    openCalculateConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t('CashFlow.Compilation.Calculate'),
        text: this.$t('CashFlow.Compilation.ConfirmCalculate', { code }),
        accept: this.calculateCompilation,
        parameters: id
      });
    },
    publishingText() {
      if (this.isCalculating) {
        return this.$t('CashFlow.Compilation.RequestSent')
      } else {
        return this.$t('CashFlow.Compilation.SendingRequest')
      }
    },
    calculateCompilation(id) {
      this.isCalculating = false;
      this.attempts = 0;
      this.$cqrsPost('cashflow/LOM/Compilations/calculate',  { compilationId : id, reportUrl: `/bsg/cashflow/reports/compilation?compilationId=${id}` }).then((response) => {
        if (response.data.model !== "OK") { //.... is this check still used?
          this.isCalculating = true;
          const job = response.data.model;
          this.$vs.notify({
            title: this.publishingText(),
            text: this.$t('CashFlow.Compilation.Calculation'),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
        else {
          this.$vs.notify({
            title: this.$t("Success"),
            text: "Published",
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
      }).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: this.$t("LoadingError"),
          text: error.message  
        })
      }).finally(() => {
        
      })
    },

    duplicate(id) {
      this.$store.dispatch("cashflow/duplicateCompilation", id).then(() => {
        this.$vs.notify({
          title: this.$t("Success"),
          text: this.$t("SaveSuccess"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
      });
      
    },

    deleteData(id) {
      this.$vs.loading();
      this.$store.dispatch("cashflow/removeCompilation", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("CashFlow.Compilation.CompilationDeleted")
          });
        }).finally(() => {
          this.$vs.loading.close();
        });
    },
    compilationUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
    },
    compilationInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
    },
    refreshCompilationList() {
      this.$store.dispatch("cashflow/fetchCompilationListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    availability(isPublic) {
      if (isPublic) {
        return this.$t('CashFlow.Lom.AvailabilityPublic');
      }
      else {
        return this.$t('CashFlow.Lom.AvailabilityPrivate');
      }
    },
    createdByUserName(createdBy) {
      if (createdBy === null || typeof createdBy === 'undefined')
        return null;

      const index = createdBy.search("@");
      if (index !== -1) {
        return createdBy.substring(0, index);
      }
      return createdBy;
    },
    formatDate(value) {
      const d = new Date(value);
      return d.toLocaleDateString();
    },
    formatTime(value) {
      const d = new Date(value);
      return d.toLocaleTimeString();
    },
    isMyCompilation(compilation) {
      const currentUserName = this.$auth.getUser().username.toLowerCase();
      if (compilation.createdBy.toLowerCase() === currentUserName || compilation.users.find(u => u.username.toLowerCase() === currentUserName && u.canEdit === true) !== undefined) {
        return true;
      }
      return false;
    },
    hasDetail(compilation) {
      return compilation.description !== "" && compilation.description !== null;
    },

    // eslint-disable-next-line no-unused-vars
    goToReport(tr) {
      this.$router.push({ name: "BSG-cashflow-reports-compilation", query: { compilationId: tr.id } });
    }
  },
  created() {
    if (!moduleCashflow.isRegistered) {
      this.$store.registerModule("cashflow", moduleCashflow);
      moduleCashflow.isRegistered = true;
    }
  },
  mounted() {
    window.location.href = odtHostname + "/bsg/";
    this.$vs.loading();

    if (!this.isMounted) {
      // do not fetch hyperion lom everytime, really slow
      if (this.$store.state.cashflow.hyperionLoms.length === 0) {
        Promise.all([
          this.$store.dispatch("cashflow/fetchProjectLomListItems"),
          this.$store.dispatch("cashflow/fetchHyperionLomListItems"),
          this.$store.dispatch("cashflow/fetchCorporateLomListItems"),
          this.$store.dispatch("cashflow/fetchYearlyFXRateTemplates"),
          this.$store.dispatch("cashflow/fetchYearlyInflationRateTemplates"),
          this.$store.dispatch("cashflow/fetchElementYearlyPriceTemplates")
        ]).finally(() => {
          this.$vs.loading.close();
        })
      } else {
        Promise.all([
          this.$store.dispatch("cashflow/fetchProjectLomListItems"),
          this.$store.dispatch("cashflow/fetchCorporateLomListItems"),
          this.$store.dispatch("cashflow/fetchYearlyFXRateTemplates"),
          this.$store.dispatch("cashflow/fetchYearlyInflationRateTemplates"),
          this.$store.dispatch("cashflow/fetchElementYearlyPriceTemplates")
        ]).finally(() => {
          this.$vs.loading.close();
        })
      }
    }
    this.isMounted = true;
    this.$refs.listCard.refreshcard();
  }
};